import React, { Component } from 'react'

import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import { Grid } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import ColorLensIcon from '@material-ui/icons/ColorLens'
import { SketchPicker } from 'react-color'
import Modal from '../../../../UI/Modal/Modal'
import Footer from '../../../..//UI/Modal/Footer/Footer'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
class form extends Component {
  state = {
    form: [],
    modalOpen: false,
    color: '#000000'
  }

  static getDerivedStateFromProps = (props, state) => {}

  componentDidMount() {
    this.setState({ color: this.props.form.color_code.value })
  }

  closeModal = () => {
    // if (this.state.action === 'edit') {
    // } else {
    this.setState({
      modalOpen: false,
      color: '#000000'
    })
    // }
  }
  handleChangeColor = color => {
    this.setState({ color: color.hex })
  }
  selectColor = () => {
    this.props.inputChanged('color_code', this.state.color)
    this.closeModal()
  }
  render() {
    const formContent = Object.entries(this.props.form).map(item => {
      let [formKey, formAttrs] = item
      if (formKey === 'color_code') {
        formAttrs.elementConfig = {
          ...formAttrs.elementConfig,
          startAdornment: (
            <IconButton>
              <label
                style={{ color: formAttrs.value }}
                // for='input-color'
                onClick={() => this.setState({ modalOpen: true })}>
                <ColorLensIcon />
              </label>
            </IconButton>
          )
        }
      }

      return (
        <Grid container key={formKey}>
          <Grid item xs={formKey === 'color_code' ? 5 : 12} sm={formKey === 'color_code' ? 3 : 12}>
            <InputGroup
              key={formKey}
              label={formAttrs.label}
              inputType={formAttrs.elementType}
              configs={formAttrs.elementConfig}
              invalid={!formAttrs.valid}
              validations={formAttrs.validation}
              touched={formAttrs.touched}
              changed={e => this.props.inputChanged(formKey, e)}
              inputValue={formAttrs.value}
              validationError={formAttrs.error}
            />
          </Grid>
          {formKey === 'color_code' ? (
            <Grid item xs={3} style={{ marginTop: 10, marginLeft: 0, marginRight: 10 }}>
              <input
                id='input-color'
                type='color'
                style={{ visibility: 'hidden' }}
                value={formAttrs.value}
                onChange={e => this.props.inputChanged(formKey, e)}
              />
            </Grid>
          ) : null}
        </Grid>
      )
    })
    let footer = (
      <Footer
        save={() => this.selectColor()}
        showAnother={false}
        cancel={() => this.closeModal()}
        disable={false}
      />
    )
    return (
      <div>
        {formContent}
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate('colorCode')}
          disableBackdropClick={true}
          size={'xs'}
          footer={footer}>
          <Grid container direction='row' justify='space-around' alignItems='center'>
            <SketchPicker color={this.state.color} onChangeComplete={this.handleChangeColor} />
          </Grid>
        </Modal>
      </div>
    )
  }
}
export default withTranslate(form)
